import 'bootstrap/dist/css/bootstrap.min.css';
import { React } from "react";
import '../../App.scss';

export default function NotFound() {

   return (
      <h1>Not found</h1>
   );
};
